import _isEmpty from 'lodash/isEmpty';
export function dropdownMenuFileOptionsMapping(values) {
  if (_isEmpty(values)) {
    return [];
  }
  return values.map(function (value) {
    return {
      key: value,
      value: value,
      text: value
    };
  });
}
export var getFileType = function getFileType(fileName) {
  if (_isEmpty(fileName)) {
    return null;
  }
  var fileComponents = fileName.split('.');
  if (fileComponents.length <= 1) {
    return null;
  }
  return fileComponents[fileComponents.length - 1];
};